import React from 'react';
import { Fab, Tooltip, Box, Typography } from '@mui/material';

const FloatingDiscordButton = () => {
  const handleDiscordClick = () => {
    window.open('https://discord.gg/gCrRJMgMEm', '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip 
      title="Join our Discord community!" 
      placement="left"
      arrow
      sx={{
        '& .MuiTooltip-tooltip': {
          bgcolor: '#5865F2',
          color: 'white',
          fontSize: '0.875rem',
          fontWeight: 500,
        },
        '& .MuiTooltip-arrow': {
          color: '#5865F2',
        },
      }}
    >
      <Box
        onClick={handleDiscordClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          background: 'linear-gradient(135deg, #5865F2 0%, #404EED 100%)',
          color: 'white',
          height: 64,
          minWidth: 200,
          borderRadius: '32px',
          boxShadow: '0 8px 32px rgba(88, 101, 242, 0.4)',
          transition: 'all 0.3s ease-in-out',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          px: 3,
          '&:hover': {
            background: 'linear-gradient(135deg, #4752C4 0%, #3c44dc 100%)',
            transform: 'scale(1.05) translateY(-2px)',
            boxShadow: '0 12px 40px rgba(88, 101, 242, 0.6)',
          },
          '&:active': {
            transform: 'scale(1.02) translateY(-1px)',
          },
          // Pulse animation
          animation: 'pulse 2s infinite',
          '@keyframes pulse': {
            '0%': {
              boxShadow: '0 8px 32px rgba(88, 101, 242, 0.4)',
            },
            '50%': {
              boxShadow: '0 8px 32px rgba(88, 101, 242, 0.6), 0 0 0 10px rgba(88, 101, 242, 0.1)',
            },
            '100%': {
              boxShadow: '0 8px 32px rgba(88, 101, 242, 0.4)',
            },
          },
        }}
      >
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="currentColor"
          style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))' }}
        >
          <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
        </svg>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            fontSize: '0.95rem',
            color: 'white',
            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
            whiteSpace: 'nowrap',
          }}
        >
          Join our Discord
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default FloatingDiscordButton; 